const orderSummaryOptions = [
  {
    property: 'email',
    label: 'Email'
  },
  {
    property: 'phone',
    label: 'Phone'
  }
];

export default { orderSummaryOptions };